<template>
    <div>
        <router-link v-if="trialId" class="tableLinkID" :to="{ name: 'TrialDetail', params: { id: trialId }}">{{ trial }}</router-link>
        <span v-else>-</span> /

        <router-link v-if="palmId" class="tableLinkID" :to="{ name: 'PalmDetail', params: { id: palmId }}">{{ palm }}</router-link>
        <span v-else>-</span>

        (<router-link v-if="progenyId" class="tableLinkID" :to="{ name: 'ProgenyDetail', params: { id: progenyId }}">{{ progeny }}</router-link>
        <span v-else>-</span>)
    </div>
</template>

<script>
export default {
    props: {
        "row": {
            type: Object
        },
        "col": {
            type: Object
        },
        "cell": {
            type: String | Number
        },
        "index": {
            type: String | Number
        }
    },
    computed: {
        data() {
            return this.cell || this.row;
        },
        trial() {
            return this.data?.trial?.trialNumber || "-";
        },
        trialId() {
            return this.data?.trialId;
        },
        palm() {
            return this.data?.trialPalmNumber || "-";
        },
        palmId() {
            return this.data?.id;
        },
        progeny() {
            return this.data?.progeny?.code || "-";
        },
        progenyId() {
            return this.data?.progenyId;
        },
        formattedPalm() {
            return `${this.trial}/${this.palm}(${this.progeny})`;
        }
    }
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Progeny/MPOBPalmFormat.vue